import Baobab from 'baobab';

const tree = new Baobab({
	category: null,
	facets: null,
	loading: false,
	product: null,
	productsToCompare: null,
	productSearchResults: null,
	searchLoading: false,
	token: null,
	support: null,
	reviews: null,
	featuredProduct: null,
	siteSearch: null
});

export default tree;


// WEBPACK FOOTER //
// ./src/state.js